var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{staticStyle:{"width":"100%"},attrs:{"id":_vm.nodeId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }